const resourceLibraryManagement = () => import('./resourceLibraryManagement');
const statisticalAnalysis = () => import('./statisticalAnalysis');

const resourceClassificationManagement = () =>
  import('./resourceClassificationManagement');

const Router = [
  {
    path: 'resourceLibraryManagement',
    name: 'resourceLibraryManagement',
    component: resourceLibraryManagement,
    meta: {
      title: '资源库管理',
    },
  },
  {
    path: 'statisticalAnalysis',
    name: 'statisticalAnalysis',
    component: statisticalAnalysis,
    meta: {
      title: '统计分析',
    },
  },
  {
    path: 'resourceClassificationManagement',
    name: 'resourceClassificationManagement',
    component: resourceClassificationManagement,
    meta: {
      title: '资源分类管理',
    },
  },
];
export default Router;
